import React, { useEffect, useState } from 'react'
import './App.css'
import { Link, Redirect } from 'react-router-dom'
import Axios from 'axios'
import Modal from 'react-bootstrap/Modal'
import ClipLoader from 'react-spinners/ClipLoader'
import Select from 'react-select'
import ReactTooltip from 'react-tooltip'
import TopBarProgress from 'react-topbar-progress-indicator'
import {
  IoIosArrowBack,
  IoIosAddCircleOutline,
  IoIosBicycle,
  IoIosNuclear,
  IoIosTrash,
  IoIosTimer,
  IoMdCheckmarkCircleOutline,
  IoIosAdd,
  IoIosInformationCircleOutline,
  IoIosCheckmarkCircleOutline,
  IoMdPrint,
  IoMdWoman,
  IoIosMan,
  IoIosWallet,
  IoIosCard,
} from 'react-icons/io'
import { BsImage, BsGraphUp, BsPip, BsWallet, BsCircle } from 'react-icons/bs'
import { BiMenu, BiPrinter } from 'react-icons/bi'
import Header3 from './components/Header3'
import {
  IoAnalyticsOutline,
  IoAtCircleOutline,
  IoAtCircleSharp,
  IoBicycleOutline,
  IoCash,
  IoCashOutline,
  IoCloudDoneOutline,
  IoCloudDownloadOutline,
  IoFlowerOutline,
  IoImageOutline,
  IoNuclearOutline,
  IoStar,
  IoTicketOutline,
  IoTrashOutline,
} from 'react-icons/io5'
import { stat } from 'fs'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import { API_URL } from './config'

const Editevent = (props) => {
  const history = useHistory()
  const baseURL = `${API_URL}/apps/kscanner/webservices.php`
  const location = useLocation()
  const preimageState = location.state?.poster || null

  const [count, setCount] = useState(0)
  const [actionBtn, setActionBtn] = useState('Postpone')
  const [details, setDetails] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [controlModal, setControlModal] = useState(false)
  const [addPoster, setAddPoster] = useState(false)
  const [postponeEvent, setPostponeEvent] = useState(false)
  const [resumeModal, setResumeModal] = useState(false)
  const [category, setCategory] = useState('vvip')
  const [price, setPrice] = useState('0')
  const [numberOftickets, setNumberOftickets] = useState('0')
  const [getVVIP, setGetVVIP] = useState('')
  const [getVVIPprice, setGetVVIPprice] = useState(0)
  const [getVIPprice, setGetVIPprice] = useState(0)
  const [getGENprice, setGetGENprice] = useState(0)
  const [getVIP, setGetVIP] = useState('')
  const [getGen, setGetGen] = useState('')
  const [itemVVIP, setItemVVIP] = useState('item-select-active pt-2')
  const [itemVIP, setItemVIP] = useState('item-select')
  const [itemGen, setItemGen] = useState('item-select')
  const [currentSelect, setCurrentSelect] = useState('VVIP')
  const [selectedPrice, setSelectedPrice] = useState(0)
  const [selectedTicket, setSelectedTicket] = useState(0)
  const [kidsSelectedPrice, setKidsSelectedPrice] = useState(0)
  const [kidsSelectedTicket, setKidsSelectedTicket] = useState(0)
  const [spinning, setSpinning] = useState('none')
  const [updateDisplay, setUpdateDisplay] = useState('block')
  const [error, setError] = useState('')
  const [successError, setSuccessError] = useState('')
  const [deletion, setDeletion] = useState('')
  const [deleted, setDeleted] = useState(0)
  const [eventPassed, setEventPassed] = useState('')
  const [image, setImage] = useState(null)
  const [path, setPath] = useState('')
  const [type, setType] = useState('image/jpeg')
  const [activeBox, setActiveBox] = useState('box-upload')
  const [numberOfcustomers, setNumberOfcustomers] = useState(0)
  const [message, setMessage] = useState('')
  const [reason, setReason] = useState('')
  const [subtype, setSubtype] = useState('postpone')
  const [hideUploadBtn, setHideUploadBtn] = useState('none')
  const [checktickets, setChecktickets] = useState('no')
  const [checkcampaign, setCheckcampaign] = useState('no')
  const [checkposter, setCheckposter] = useState('no')
  const [loadBarProgress, setLoadBarProgress] = useState(false)
  const [printed, setPrinted] = useState('')
  const [ticketCount, setTicketCount] = useState(0)
  const [eventtype, setEventtype] = useState('')
  const [kids_vvip_tickets, setKids_vvipTickets] = useState(0)
  const [kids_vip_tickets, setKidsVipTickets] = useState(0)
  const [kids_general_tickets, setKidsGeneralTickets] = useState(0)
  const [kids_vvip_price, setKids_vvip_price] = useState(0)
  const [kids_vip_price, setKidsVipPrice] = useState(0)
  const [kids_general_price, setKidsGeneralPrice] = useState(0)
  const [errorDisplay, setErrorDisplay] = useState('none')
  const [imgname, setImgname] = useState('')
  const [preimage, setPreimage] = useState(preimageState)
  const [delString, setDelString] = useState(null)
  const [kids_price, setKidsPrice] = useState(0)
  const [kids_tickets, setKidsTickets] = useState(0)
  const [checkCampaignStatus, setCheckCampaignStatus] = useState('stop')
  const [cancelTitle, setCancelTitle] = useState('Cancel')
  const [cancelledAt, setCancelledAt] = useState(null)

  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState()
  const [collapsed, setCollapsed] = useState(isMobile)

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  const {
    eventname,
    eventdate,
    eventid,
    poster,
    theme,
    venue,
    expectednum,
    enddate,
    time,
    endtime,
    event_date,
    finish_date,
    campaignstatus,
    is_sponsorship,
    prevpage,
  } = location.state || {}

  useEffect(() => {
    const businessname = localStorage.getItem('businessname')
    const businessid = localStorage.getItem('businessid')
    document.title = `${eventname} - ${businessname}`

    const date = new Date()
    const fulldate = date.toISOString().split('T')[0] // YYYY-MM-DD

    const activeClass = deleted === 1 ? 'item-names-disabled' : 'item-names'

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=EVENTTYPE&eventid=${eventid}`, {
      withCredentials: true,
    }).then((res) => setEventtype(res.data.eventtype))

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=REPRINTABLETICKETS&eventid=${eventid}`,
      {
        withCredentials: true,
      }
    ).then((res) => {
      if (res.data.val === 0 || res.data.ticketCount === 0) {
        setPrinted('')
      } else {
        setTicketCount(res.data.ticketCount)
        setPrinted(
          <div className="reprint-select w-100">
            <div
              className="w-100 menu-links"
              onClick={
                event_date >= fulldate &&
                deleted == 0 &&
                checktickets === 'yes' &&
                checkposter === 'yes' &&
                checkcampaign === 'yes'
                  ? () => reprint()
                  : () => functionControl()
              }
            >
              <div className="col-lg-2 col-2 col-sm-1 text-center">
                <IoCloudDownloadOutline size={30} className={activeClass} color="#fff" />
              </div>
              <div className={'col-lg-10 col-10 col-sm-10'}>
                <label className={`${activeClass} w-100 mb-0 color-white`}>
                  Re-download tickets
                  <label className="float-right">{res.data.ticketCount}</label>
                </label>
              </div>
            </div>
          </div>
        )
      }
    })

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=CHECKCAMPAIGN&eventid=${eventid}`, {
      withCredentials: true,
    }).then((res) => {
      if (res.data.thumbnail === 'yes') {
        setPreimage(
          `${API_URL}/apps/kscanner/posters/${res.data.businessid}/${res.data.eventid}/${res.data.image}`
        )
      }
      setCheckcampaign(res.data.checkcampaign)
      setCheckposter(res.data.thumbnail)
    })

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=CHECKTICKETS&eventid=${eventid}`, {
      withCredentials: true,
    }).then((res) => setChecktickets(res.data.tickets))

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=EVENTSALESDATA&eventid=${eventid}`, {
      withCredentials: true,
    }).then((res) => setNumberOfcustomers(res.data.numberOfcustomers))

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=CHECKIFEVENTDELETED&eventid=${eventid}`,
      {
        withCredentials: true,
      }
    ).then((res) => {
      const deletionStatus = res.data.deletion
      const eventDay = res.data.event_day
      const postponed_at = res.data.postponed_at
      const cancelled_at = res.data.cancelled_at
      const updated_at = res.data.updated_at

      setCancelledAt(res.data.cancelled_at)
      let deletionMarkup

      if (cancelled_at != null || postponed_at != null) {
        deletionMarkup = (
          <div style={{ textTransform: 'none', fontWeight: 400 }}>
            <label
              className={`${
                cancelled_at != null ? 'bg-red text-red' : 'bg-orange text-orange'
              }  mb-0 pl-2 pr-2 border-radius-5`}
            >
              This event was officially {postponed_at != null ? 'postponed' : 'cancelled'} on{' '}
              {updated_at}. All associated ticket holders have been notified.
            </label>
          </div>
        )
      } else if (eventDay < fulldate) {
        deletionMarkup = (
          <div style={{ textTransform: 'none', fontWeight: 400, color: '#ffae19' }}>
            <label className="bg-orange mb-0 pl-2 pr-2 border-radius-5">
              This event concluded on {eventdate}
            </label>
          </div>
        )
      } else if (deletionStatus === 1) {
        deletionMarkup = (
          <div style={{ textTransform: 'none', fontWeight: 400, color: 'red' }}>
            <h5>This event has been deleted</h5>
          </div>
        )
      } else {
        deletionMarkup = (
          <div style={{ textTransform: 'none', fontWeight: 400, color: '#4ca64c' }}>
            <label className="bg-green mb-0 pl-2 pr-2 border-radius-5">
              This event is scheduled to take place on {eventdate}
            </label>
          </div>
        )
      }

      setDeleted(deletionStatus)
      setDeletion(deletionMarkup)
    })

    // Check campaign status for current event
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GET-CAMPAIGN-STATUS&eventid=${eventid}`,
      {
        withCredentials: true,
      }
    ).then((res) => {
      // console.log(res.data.campaign_status);
      setCheckCampaignStatus(res.data.campaign_status ?? 'stop')
    })

    // Fetch VVIP ticket details
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GETVVIPDETAILS&accountid=${businessid}&eventid=${eventid}`,
      {
        withCredentials: true,
      }
    ).then((res) => {
      setGetVVIP(res.data.vvipticketavail ?? 0)
      setGetVVIPprice(res.data.vvipprice ?? 0)
      setPrice(res.data.vvipprice ?? 0)
      setKidsPrice(res.data.kids_vvip_price ?? 0)
      setKidsTickets(res.data.kids_vvip_tickets ?? 0)

      // setSelectedTicket(res.data.vvipticketavail ?? 0);
      setSelectedTicket(0)
      setSelectedPrice(res.data.genprice ?? res.data.vvipprice)
      setKidsSelectedPrice(res.data.kids_price ?? res.data.kids_vvip_price)
      // setKidsSelectedTicket(res.data.kids_tickets ?? 0);
      setKidsSelectedTicket(0)
    })

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GETVIPDETAILS&accountid=${businessid}&eventid=${eventid}`,
      {
        withCredentials: true,
      }
    ).then((res) => {
      setGetVIP(res.data.vipticketavail ?? 0)
      setGetVIPprice(res.data.vipprice ?? 0)
      setKidsVipPrice(res.data.kids_vip_price ?? 0)
      setKidsVipTickets(res.data.kids_vip_tickets ?? 0)
    })

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GETGENDETAILS&accountid=${businessid}&eventid=${eventid}`,
      {
        withCredentials: true,
      }
    ).then((res) => {
      setGetGen(res.data.genticketavail ?? 0)
      setGetGENprice(res.data.genprice ?? 0)
      setKidsGeneralPrice(res.data.kids_general_price ?? 0)
      setKidsGeneralTickets(res.data.kids_general_tickets ?? 0)
    })

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      // this runs on unmount
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [count, eventid, eventname, event_date, deleted, checkcampaign, checkposter, checktickets])

  const reprint = () => {
    const eventid = props.location.state.eventid
    const eventname = props.location.state.eventname
    localStorage.setItem('eventid', eventid)
    localStorage.setItem('eventname', eventname)
    history.push({
      pathname: '/download',
      state: {
        reprint: 'yes',
      },
    })
  }

  const closeModal = () => {
    setShowModal(false)
    setDeleteModal(false)
    setAddPoster(false)
    setControlModal(false)
    setPostponeEvent(false)
    setResumeModal(false)
    setErrorDisplay('none')
  }

  const openModal = () => {
    setShowModal(true)
    setCancelTitle('Cancel')
  }

  const delModal = () => {
    setDeleteModal(true)
  }

  const addAPoster = () => {
    setAddPoster(true)
  }

  const activateVVIP = () => {
    setItemVIP('item-select')
    setItemVVIP('item-select-active pt-2')
    setItemGen('item-select')
    setCurrentSelect('VVIP')
    // setSelectedTicket(getVVIP);
    setSelectedTicket(0)
    setSelectedPrice(getVVIPprice)
    setKidsSelectedPrice(kids_price)
    setKidsSelectedTicket(0)
    // setKidsSelectedTicket(kids_tickets);
  }

  const activateGen = () => {
    setItemVIP('item-select')
    setItemVVIP('item-select')
    setItemGen('item-select-active pt-2')
    setCurrentSelect('General')
    // setSelectedTicket(getGen);
    setSelectedTicket(0)
    setSelectedPrice(getGENprice)
    setKidsSelectedPrice(kids_general_price)
    // setKidsSelectedTicket(kids_general_tickets);
    setKidsSelectedTicket(0)
  }

  const activateVIP = () => {
    setItemVIP('item-select-active pt-2')
    setItemVVIP('item-select')
    setItemGen('item-select')
    setCurrentSelect('VIP')
    // setSelectedTicket(Number(getVIP));
    setSelectedTicket(0)
    setSelectedPrice(Number(getVIPprice))
    setKidsSelectedPrice(Number(kids_vip_price))
    setKidsSelectedTicket(0)
    // setKidsSelectedTicket(Number(kids_vip_tickets));
  }

  const handleTickets = (event) => {
    setSelectedTicket(event.target.value)
    setErrorDisplay('none')
  }

  const handlePrice = (event) => {
    setSelectedPrice(event.target.value)
    setErrorDisplay('none')
  }

  const handle_kids_tickets = (event) => {
    setKidsSelectedTicket(event.target.value)
    setErrorDisplay('none')
  }

  const handle_kids_price = (event) => {
    setKidsSelectedPrice(event.target.value)
    setErrorDisplay('none')
  }

  const cancel = () => {
    setShowModal(false)
    setDeleteModal(false)
    setControlModal(false)
    setResumeModal(false)
    setErrorDisplay('none')
  }

  const update = async () => {
    const businessid = localStorage.getItem('businessid')
    const { eventname, eventid } = location.state || {}

    const price = selectedPrice
    const numberOftickets = selectedTicket
    const kids_price = kidsSelectedPrice
    const kids_tickets = kidsSelectedTicket
    const category = currentSelect.toLowerCase()

    // if (
    //   (numberOftickets <= 0 || numberOftickets === "") &&
    //   (kids_tickets <= 0 || kids_tickets === "")
    // ) {
    //   setError(
    //     "At least one group must have tickets available. i.e. Adults or Kids"
    //   );
    //   setErrorDisplay("block");
    //   setSuccessError("error-login");
    //   setUpdateDisplay("block");
    //   setSpinning("none");
    // }
    if (numberOftickets > 0 && (price <= 0 || price === '')) {
      setError('Ticket price cannot be empty or R0.0 for Adults')
      setErrorDisplay('block')
      setSuccessError('error-login')
      setUpdateDisplay('block')
      setSpinning('none')
    } else if (numberOftickets > 0 && isNaN(price)) {
      setError('Invalid ticket price for Adults.')
      setErrorDisplay('block')
      setSuccessError('error-login')
      setUpdateDisplay('block')
      setSpinning('none')
    }
    // else if (price > 0 && (numberOftickets <= 0 || numberOftickets === "")) {
    //   setError("Indicate how many tickets are to be available for Adults.");
    //   setErrorDisplay("block");
    //   setSuccessError("error-login");
    //   setUpdateDisplay("block");
    //   setSpinning("none");
    // }
    else if (kids_tickets > 0 && (kids_price <= 0 || kids_price === '')) {
      setError('Ticket price cannot be empty or R0.0 for Kids.')
      setErrorDisplay('block')
      setSuccessError('error-login')
      setUpdateDisplay('block')
      setSpinning('none')
    } else if (kids_tickets > 0 && isNaN(kids_price)) {
      setError('Invalid ticket price, please enter a number for Kids.')
      setErrorDisplay('block')
      setSuccessError('error-login')
      setUpdateDisplay('block')
      setSpinning('none')
    }
    // else if (kids_price > 0 && (kids_tickets <= 0 || kids_tickets === "")) {
    //   setError("Indicate how many tickets are to be available for Kids.");
    //   setErrorDisplay("block");
    //   setSuccessError("error-login");
    //   setUpdateDisplay("block");
    //   setSpinning("none");
    // }
    else {
      setUpdateDisplay('none')
      setSpinning('block')
      setLoadBarProgress(true)

      const dataForm = new FormData()

      dataForm.append('price', price)
      dataForm.append('numberOftickets', numberOftickets)
      dataForm.append('category', category)
      dataForm.append('eventid', eventid)
      dataForm.append('kids_price', kids_price)
      dataForm.append('kids_tickets', kids_tickets)
      dataForm.append('query', 'ADDTICEKTS')

      await Axios({
        method: 'POST',
        url: baseURL,
        data: dataForm,
        withCredentials: true,
      }).then((response) => {
        setCount(count + 1)
        if (response.data.status === 'failed') {
          setError(response.data.error)
          setErrorDisplay('block')
          setSuccessError('error-login')

          setTimeout(() => {
            setErrorDisplay('none')
          }, 5000)
        } else {
          setError(response.data.message)
          setErrorDisplay('block')
          setSuccessError(response.data.status == 'warning' ? 'warning-bg' : 'success-login')
          setUpdateDisplay('block')
          setSpinning('none')
          setChecktickets('yes')

          setLoadBarProgress(false)
          setCancelTitle('Done')
          // setShowModal(false);
          setDeleteModal(false)
          setAddPoster(false)
          setControlModal(false)
          setPostponeEvent(false)
          setResumeModal(false)

          setTimeout(() => {
            setErrorDisplay('none')
          }, 5000)

          /* history.push({
            pathname: "/editevent",
            state: {
              campaignstatus,
              eventid,
              eventname,
              poster,
              eventdate,
              enddate,
              event_date,
              finish_date,
              theme,
              venue,
              expectednum,
              time,
              endtime,
              prevpage,
            },
          });*/
        }
      })
    }

    setTimeout(() => {
      setErrorDisplay('none')
    }, 4000)
  }

  const deleteEvent = () => {
    const { eventid } = location.state || {}
    const data = new FormData()
    data.append('eventid', eventid)
    data.append('query', 'DELETEEVENT')

    Axios({
      method: 'POST',
      url: baseURL,
      data: data,
      withCredentials: true,
    })
      .then((response) => {
        // setCount(count + 1);
        if (response.data.status === 'success') {
          history.goBack()
        } else {
          setError(response.data.message || 'Something went wrong.')
          setErrorDisplay('block')
          setSuccessError('error-login')
          setUpdateDisplay('block')
          setSpinning('none')
        }
      })
      .catch((error) => {
        const message =
          error.response?.data?.message ||
          "We couldn't complete your request. Please check your connection or try again shortly."
        setError(message)
        setErrorDisplay('block')
        setSuccessError('error-login')
        setUpdateDisplay('block')
        setSpinning('none')
      })

    setTimeout(() => {
      setUpdateDisplay('none')
    }, 5000)
  }

  const functionControl = () => {
    if (checkcampaign == 'no') {
      setControlModal(true)
      setDelString('You have to create a campaign first')
    } else if (deleted == 1) {
      setControlModal(true)
      setDelString("This event has been deleted, it can't be edited")
    } else {
      setControlModal(true)
      setDelString("This event has already passed, it can't be edited")
    }
  }

  const campaign = () => {
    const eventid = props.location.state.eventid
    const eventname = props.location.state.eventname
    const prevpage = props.location.state.prevpage
    const currentpage = 'editevent'
    const eventdate = props.location.state.eventdate
    const poster = props.location.state.poster
    const theme = props.location.state.theme
    const venue = props.location.state.venue
    const expectednum = props.location.state.expectednum
    const enddate = props.location.state.enddate
    const time = props.location.state.time
    const endtime = props.location.state.endtime
    const event_date = props.location.state.event_date
    const finish_date = props.location.state.finish_date
    history.push({
      pathname: 'campaign',
      state: {
        eventid: eventid,
        eventname: eventname,
        poster: poster,
        eventdate: eventdate,
        enddate: enddate,
        event_date: event_date,
        finish_date: finish_date,
        theme: theme,
        venue: venue,
        expectednum: expectednum,
        time: time,
        endtime: endtime,
        prevpage: prevpage,
        currentpage: currentpage,
      },
    })
  }

  const selectImage = (event) => {
    const img = event.target.files[0]
    const previewURL = URL.createObjectURL(img)
    // alert(img.name);

    setImage(previewURL)
    setPreimage(previewURL)
    setImgname(img)
    setType(img.type)
    setPath(previewURL)
    setActiveBox('box-upload-dis')
    setHideUploadBtn('block')
  }

  const uploadPoster = async () => {
    const eventid = props.location.state.eventid
    const accountid = localStorage.getItem('businessid')
    // const type_ = type;
    // const path_ = path;
    const fileName = imgname
    let data = new FormData()
    setUpdateDisplay('none')
    setSpinning('block')

    // alert(path);

    // data.append("file", { type: type, uri: path, name: path.split("/").pop() });
    data.append('file', imgname)
    data.append('eventid', eventid)
    data.append('businessid', accountid)
    data.append('query', 'POSTERUPLOAD')

    if (image === '') {
      setError('Please select a poster')
      setErrorDisplay('block')
      setSuccessError('error-login')
      setUpdateDisplay('block')
      setSpinning('none')
    } else {
      await Axios({
        url: `${API_URL}/apps/kscanner/webservices.php`,
        method: 'POST',
        data: data,
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then((response) => {
          setError(response.data.message)
          setErrorDisplay('block')
          setSuccessError(response.data.status === 'success' ? 'success-alert' : 'error-alert')
          setUpdateDisplay('block')
          setSpinning('none')
          setAddPoster(false)
          setCheckposter('yes')
          setLoadBarProgress(false)
          setShowModal(false)
          setDeleteModal(false)
          setControlModal(false)
          setPostponeEvent(false)
          setResumeModal(false)
        })
        .catch((error) => {
          console.log('image upload error: ', error)
        })

      setTimeout(() => {
        setErrorDisplay('none')
      }, 4000)

      history.push({
        pathname: '/editevent',
        state: {
          campaignstatus,
          eventid,
          eventname,
          poster,
          eventdate,
          enddate,
          event_date,
          finish_date,
          theme,
          venue,
          expectednum,
          time,
          endtime,
          prevpage,
        },
      })
    }
  }

  const postpone = () => {
    setPostponeEvent(true)
    setSubtype('postpone')
    setActionBtn('Confirm Postponement')
  }

  const cancelModal = () => {
    setPostponeEvent(true)
    setSubtype('cancel')
    setActionBtn('Confirm Cancellation')
  }

  const handleChange = (e) => {
    setReason(e.value) // or e.target.value if it's an input
  }

  const handleMessage = (event) => {
    setMessage(event.target.value)
    setErrorDisplay('none')
  }

  const postponeTheEvent = () => {
    const eventid = props.location.state.eventid
    const businessid = localStorage.getItem('businessid')
    const type = subtype
    // const message = message;
    // const reason = reason;

    if (reason === '') {
      setError('Select a reason for the postponement ')
      setErrorDisplay('block')
      setSuccessError('error-login')
    } else if (message.trim() === '') {
      setError('Write a message ')
      setErrorDisplay('block')
      setSuccessError('error-login')
    } else {
      setSpinning('block')
      const data = new FormData()
      data.append('query', 'POSTPONE')
      data.append('businessid', businessid)
      data.append('eventid', eventid)
      data.append('type', type)
      data.append('message', message)
      data.append('reason', reason)

      Axios.post(`${API_URL}/apps/kscanner/webservices.php`, data, {
        withCredentials: true,
      })
        .then((response) => {
          let string = ''
          if (response.data.status === 'success') {
            setCount(count + 1)
            if (subtype === 'postpone') {
              string = 'postponed'
            } else {
              string = 'cancelled'
            }
            setError(response.data.message)
            setErrorDisplay('block')
            setSuccessError('success-login')

            setShowModal(false)
            setDeleteModal(false)
            setPostponeEvent(false)
          } else {
            setError(response.data.message)
            setErrorDisplay('block')
            setSuccessError('error-login')
          }

          setTimeout(() => {
            setErrorDisplay('none')
          }, 6000)
          setSpinning('none')
        })
        .catch((err) => {
          setError(err)
          setErrorDisplay('block')
          setSuccessError('error-login')

          setTimeout(() => {
            setErrorDisplay('none')
          }, 6000)
          setSpinning('none')
        })
    }
  }

  const resumeAModal = () => {
    setResumeModal(true)
  }

  const resumeCampaign = () => {
    const eventid = props.location.state.eventid
    const accountid = localStorage.getItem('businessid')
    const accounttype = localStorage.getItem('accounttype')
    const eventname = props.location.state.eventname

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=RESUMECAMPAIGN&eventid=${eventid}&businessid=${accountid}`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        if (response.data.status === 'failed') {
          setResumeModal(false)
          setCount(count + 1)
          setError(response.data.message)
          setErrorDisplay('block')
          setSuccessError('error-login')
        } else {
          setResumeModal(false)
          setCount(count + 1)
          setError(response.data.message)
          setErrorDisplay('block')
          setSuccessError(response.data.status === 'stop' ? 'error-login' : 'success-login')
        }
      })
      .catch((error) => {
        setError(error)
        setErrorDisplay('block')
        setSuccessError('error-login')
      })

    setTimeout(() => {
      setErrorDisplay('none')
    }, 4000)
  }

  const downloadTickets = () => {
    const eventid = props.location.state.eventid
    const eventname = props.location.state.eventname
    const prevpage = props.location.state.prevpage
    const currentpage = 'editevent'
    const eventdate = props.location.state.eventdate
    const poster = props.location.state.poster
    const theme = props.location.state.theme
    const venue = props.location.state.venue
    const expectednum = props.location.state.expectednum
    const enddate = props.location.state.enddate
    const time = props.location.state.time
    const endtime = props.location.state.endtime
    const event_date = props.location.state.event_date
    const finish_date = props.location.state.finish_date
    localStorage.setItem('eventname', eventname)
    localStorage.setItem('download', 'download')
    localStorage.setItem('eventid', eventid)
    history.push({
      pathname: '/downloadtickets',
      state: {
        eventid: eventid,
        eventname: eventname,
        poster: poster,
        eventdate: eventdate,
        enddate: enddate,
        event_date: event_date,
        finish_date: finish_date,
        theme: theme,
        venue: venue,
        expectednum: expectednum,
        time: time,
        endtime: endtime,
        prevpage: prevpage,
        currentpage: currentpage,
      },
    })
  }

  const addModels = () => {
    const eventid = props.location.state.eventid
    localStorage.removeItem('modelid')
    localStorage.setItem('eventid', eventid)
    history.push({
      pathname: '/addmodels',
    })
  }

  if (localStorage.getItem('businessid') === null) {
    return <Redirect to="/login" />
    //   return exit(1);
  } else {
  }

  const data = [
    { value: 'covid-19 restrictions', label: 'Covid-19 restrictions' },
    { value: 'venue cancelled', label: 'Venue cancelled' },
    { value: 'sponsor pulls out', label: 'Sponsor pulls out' },
    {
      value: 'unfavorable weather conditions',
      label: 'Unfavorable weather conditions',
    },
    { value: 'missing paperwork', label: 'Missing paperwork' },
    { value: 'competing events', label: 'Competing events' },
    { value: 'other', label: 'Other' },
  ]

  let active = 'item-names-disabled'
  if (deleted == 1) {
    active = 'item-names-disabled'
  } else {
    active = 'item-names'
  }

  const currentage = 'editevent'

  const businessname = localStorage.getItem('businessname')
  let { passEvent, statusString } = ''

  if (checkCampaignStatus === 'stop') {
    statusString = 'Resume Campaign'
  } else {
    statusString = 'Pause Campaign'
  }

  const date = new Date()
  let day = date.getDate()
  let month = date.getMonth() + 1

  if (month < 10) {
    month = '0' + month
  } else {
    month = month
  }

  if (day < 10) {
    day = '0' + day
  } else {
    day = day
  }

  const year = date.getFullYear()
  const fulldate = year + '-' + month + '-' + day

  if (event_date < fulldate) {
    active = 'item-names-disabled'
  } else {
    active = active
  }

  let analyticsActive = ''

  if ((event_date <= fulldate || event_date >= fulldate) && deleted == 0) {
    analyticsActive = 'item-names'
  } else {
    analyticsActive = 'item-names-disabled'
  }

  const handleToggle = () => {
    setCollapsed((prev) => !prev)
  }

  return (
    <div className="view">
      {loadBarProgress && <TopBarProgress />}
      {/* <Header3 /> */}
      <Header />
      <SideNav collapsed={collapsed} onToggle={handleToggle} />
      <div
        className="container edit_page"
        style={{
          marginLeft: isMob ? '0px' : collapsed ? 'auto' : '19%',
        }}
      >
        {/* ✅ Mobile overlay when sidebar is open */}
        {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}

        {isMob && collapsed && (
          <label className="mobile-toggle" onClick={handleToggle}>
            <BiMenu size={25} />
          </label>
        )}
        <Modal show={resumeModal} onHide={closeModal} centered>
          <div className="col-12">
            <div className="row justify-content-center align-self-center">
              <div className="col-12 text-center mb-2">
                <label className="small-details">
                  {checkCampaignStatus == 'stop' ? (
                    <label>
                      Click Resume to make your event live again. You can pause or update it
                      anytime.
                    </label>
                  ) : (
                    <label>
                      Click to Pause your campaign. The event will be hidden from the public, but
                      you can resume anytime.
                    </label>
                  )}
                </label>
              </div>

              <div className="col-12 text-center">
                <label className="back-arrow mr-1">
                  <div
                    className={checkCampaignStatus === 'stop' ? 'save-btn' : 'btn btn-info'}
                    onClick={() => resumeCampaign()}
                    style={{ padding: '5px 10px 5px 10px' }}
                  >
                    <span
                      style={{
                        display: updateDisplay,
                      }}
                    >
                      {checkCampaignStatus === 'stop' ? 'Resume Campaign' : 'Pause Campaign'}
                    </span>
                    <span
                      style={{
                        display: spinning,
                      }}
                    >
                      <ClipLoader
                        color={'#fff'}
                        loading={true}
                        // css={override}
                        size={20}
                      />
                    </span>
                  </div>
                </label>
                <label className="back-arrow ml-1">
                  <div className="cancel-btn" onClick={() => cancel()}>
                    <span
                      style={{
                        display: updateDisplay,
                      }}
                    >
                      {' '}
                      Cancel
                    </span>
                    <span
                      style={{
                        display: spinning,
                      }}
                    >
                      <ClipLoader
                        color={'#fff'}
                        loading={true}
                        // css={override}
                        size={20}
                      />
                    </span>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </Modal>

        <Modal show={postponeEvent} onHide={closeModal} centered>
          <div className="col-12 p-0 modalBGcolor">
            <div className="row justify-content-center align-self-center">
              <div className="row text-center mb-4 p-0 justify-content-end align-self-center">
                <div className="text-left w-100">
                  <h5>
                    {actionBtn === 'Confirm Cancellation'
                      ? 'Confirm Cancellation'
                      : 'Confirm Postponement'}
                  </h5>
                </div>
                <div className="col-12 pl-0 pr-0 pt-0 pb-0">
                  <div className="h-divider w-100"></div>
                </div>

                <div className="col-12 text-left pl-0 pr-0">
                  <select
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    className="form-control"
                  >
                    <option value="">Select a reason</option>
                    {data.map((obj) => (
                      <option key={obj.value} value={obj.value}>
                        {obj.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div
                  className="col-12 mt-4 mb-2 justify-content-center  pl-0 pr-0"
                  style={{ display: 'flex' }}
                >
                  {/* <select>
                      <option>fdfd</option>
                    </select> */}
                  <textarea
                    placeholder={'Write message (also propose a new date)'}
                    onChange={handleMessage}
                  />
                </div>

                <div className="col-12 text-center">
                  <label className="bg-orange text-orange p-2 border-radius-5">
                    {numberOfcustomers == 1
                      ? '1 ticket holder will be notified.'
                      : `${numberOfcustomers} ticket holders will be notified.`}
                  </label>
                </div>

                <div className="col-12">
                  {actionBtn === 'Confirm Cancellation'
                    ? 'This action is final. Once cancelled, the event cannot be reinstated.'
                    : ''}
                </div>
                <div className="col-12 mt-4">
                  <button
                    type="button"
                    className={spinning === 'block' ? 'btn-disabled mr-2' : 'save-btn mr-2'}
                    onClick={postponeTheEvent}
                    disabled={spinning === 'block' ? true : false}
                  >
                    <span className={spinning === 'block' ? 'd-none' : ''}>{actionBtn}</span>
                    <span className={spinning === 'none' ? 'd-none' : ''}>
                      <ClipLoader
                        color={'grey'}
                        loading={true}
                        // css={override}
                        size={20}
                      />
                    </span>
                  </button>

                  <button
                    type="button"
                    className="cancel-btn"
                    onClick={() => closeModal()}
                    disabled={spinning === 'block' ? true : false}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal show={addPoster} onHide={closeModal} centered>
          <div className="col-12 p-0 modalBGcolor">
            <div className="row justify-content-center align-self-center">
              <div className="row w-100 mb-0 justify-content-end align-self-center">
                <div className="d-flex w-100 pt-0 pb-0 align-items-center p-0">
                  <span className="font-size-20 float-left">Upload Poster</span>
                  <label className="d-flex align-items-end ml-auto">
                    <label
                      className="save-btn ml-auto mr-2"
                      style={{ display: hideUploadBtn }}
                      onClick={uploadPoster}
                    >
                      <span
                        style={{
                          display: updateDisplay,
                        }}
                      >
                        {poster.trim() == '' ? 'Add' : 'Update'}
                      </span>
                      <span
                        style={{
                          display: spinning,
                        }}
                      >
                        <ClipLoader
                          color={'#fff'}
                          loading={true}
                          // css={override}
                          size={20}
                        />
                      </span>
                    </label>
                    <label className="cancel-btn" onClick={() => closeModal()}>
                      <span
                        style={{
                          display: updateDisplay,
                        }}
                      >
                        Close
                      </span>
                      <span
                        style={{
                          display: spinning,
                        }}
                      >
                        <ClipLoader color={'#fff'} loading={true} size={20} />
                      </span>
                    </label>
                  </label>
                </div>

                <div
                  className="col-12 mt-0 mb-0 justify-content-center p-0"
                  style={{ display: 'flex' }}
                >
                  <label
                    className={`${activeBox} w-100 mb-0`}
                    style={{
                      backgroundImage: 'url(' + image + ')',
                      backgroundSize: 'contain',
                      // backgroundRepeat: "no-repeat",
                      backgroundPosition: 'center',
                    }}
                  >
                    <div className="d-flex justify-content-center align-items-center">
                      <div className="">
                        <IoIosAdd size={40} />
                      </div>
                      <div className="small-details w-100">Click to select poster</div>
                    </div>

                    <input
                      name="file"
                      type="file"
                      onChange={selectImage}
                      id="image"
                      accept={'.jpg,.jpeg,.png, .webp, .gif'}
                      className="hide-file-input-type"
                    />
                    {/* <img
                        src={image}
                        width={"100%"}
                        htmlFor="image"
                        className="img-poster"
                      /> */}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal show={controlModal} onHide={closeModal} centered>
          <div className="col-12 p-0">
            <div className="row justify-content-center align-self-center">
              <div className="col-12 text-center mb-4 p-0">
                <label className="small-details">
                  {checktickets == 'no' ? (
                    <label>
                      {' '}
                      You first have to{' '}
                      <label onClick={openModal} className={'color-blue'}>
                        {' '}
                        load tickets
                      </label>{' '}
                      before you can do anything.
                    </label>
                  ) : checkposter == 'no' ? (
                    <label>
                      {' '}
                      Now that tickets are loaded,{' '}
                      <label onClick={addAPoster} className={'color-blue'}>
                        {' '}
                        upload a poster
                      </label>{' '}
                      and then create a campaign
                    </label>
                  ) : (
                    delString
                  )}
                </label>
              </div>

              <div className="col-lg-3 col-3 text-right p-0">
                <label className="back-arrow">
                  <div className="cancel-btn" onClick={() => cancel()}>
                    <span
                      style={{
                        display: updateDisplay,
                      }}
                    >
                      Close
                    </span>
                    <span
                      style={{
                        display: spinning,
                      }}
                    >
                      <ClipLoader
                        color={'#fff'}
                        loading={true}
                        // css={override}
                        size={20}
                      />
                    </span>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </Modal>

        <Modal show={deleteModal} onHide={closeModal} centered>
          <div className="col-12 pt-4 pb-2 p-0 modalBGcolor">
            <div className="row justify-content-center align-self-center">
              <div className="col-12 text-center mb-4">
                <label className="">
                  Are you sure you want to delete this event? This action is permanent and cannot be
                  undone.
                </label>
              </div>

              <div className="col-12 text-center">
                <button type="button" className="save-btn mr-2" onClick={() => deleteEvent()}>
                  <span
                    style={{
                      display: updateDisplay,
                    }}
                  >
                    {' '}
                    Confirm deletion
                  </span>
                  <span
                    style={{
                      display: spinning,
                    }}
                  >
                    <ClipLoader
                      color={'#fff'}
                      loading={true}
                      // css={override}
                      size={20}
                    />
                  </span>
                </button>

                <button type="button" className="cancel-btn" onClick={() => cancel()}>
                  <span
                    style={{
                      display: updateDisplay,
                    }}
                  >
                    {' '}
                    Cancel
                  </span>
                  <span
                    style={{
                      display: spinning,
                    }}
                  >
                    <ClipLoader
                      color={'#fff'}
                      loading={true}
                      // css={override}
                      size={20}
                    />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </Modal>
        <Modal show={showModal} onHide={closeModal} centered>
          <div className="col-12 pb-0 p-0 modalBGcolor">
            <div className="row justify-content-end align-self-center">
              <div className="col-12 p-0">
                <h4>Load Tickets</h4>
              </div>
            </div>
            <div class="h-divider w-100"></div>
            <div className={itemVVIP + ' w-100 mb-2'} onClick={() => activateVVIP()}>
              <div
                to={{
                  pathname: 'logout',
                }}
                className="w-100 menu-links pb-2 pt-0"
              >
                <div className="col-12">
                  <label className="item-names small-details text-13 pb-0 mb-0">
                    <span className="color-black">VVIP</span> <br />
                    <label className="mb-0" style={{ fontWeight: 400 }}>
                      Loaded: {getVVIP}, Price: R{getVVIPprice} - <span>Adults</span>
                      <br />
                      Loaded: {kids_tickets}, Price: R{kids_price} - <span>Kids</span>
                    </label>
                  </label>
                </div>
              </div>
            </div>

            <div className={itemVIP + ' w-100 mb-2'} onClick={() => activateVIP()}>
              <div
                to={{
                  pathname: 'logout',
                }}
                className="w-100 menu-links pb-2 pt-0"
              >
                <div className="col-12">
                  <label className="item-names small-details text-13 mb-0">
                    <span className="color-black">VIP</span> <br />
                    <label className="mb-0" style={{ fontWeight: 400 }}>
                      {' '}
                      Loaded: {getVIP}, Price: R{getVIPprice} - <span>Adults</span>
                      <br />
                      Loaded: {kids_vip_tickets}, Price: R{kids_vip_price} - <span>Kids</span>
                    </label>
                  </label>
                </div>
              </div>
            </div>

            <div className={itemGen + ' w-100 mb-2'} onClick={() => activateGen()}>
              <div
                to={{
                  pathname: 'logout',
                }}
                className="w-100 menu-links pb-2 pt-0"
              >
                <div className="col-12">
                  <label className="item-names small-details text-13 mb-0">
                    <span className="color-black">General</span> <br />
                    <label className="mb-0" style={{ fontWeight: 400 }}>
                      {' '}
                      Loaded: {getGen}, Price: {getGENprice} - <span>Adults</span>
                      <br />
                      Loaded: {kids_general_tickets}, Price: R{kids_general_price} -{' '}
                      <span>Kids</span>
                    </label>
                  </label>
                </div>
              </div>
            </div>
            <div className="h-divider w-100"></div>
            <div className="col-12 mt-4 mb-4 p-0 text-13">
              <span>Ticket type: </span> {currentSelect}
              <br />
              <br />
              <span className="w-100">Adults</span>
              <br />
              <div className="row">
                <div className="col-6 pl-0 text-13">
                  Ticket price
                  <br />
                  <input
                    type="text"
                    placeholder="Price"
                    value={selectedPrice}
                    onChange={handlePrice}
                    className="edit-input"
                  />
                </div>
                <div className="col-6 pr-0 text-13">
                  Add or top-up tickets
                  <br />
                  <input
                    type="text"
                    placeholder="Load tickets"
                    value={selectedTicket}
                    onChange={handleTickets}
                    className="edit-input"
                  />
                </div>
              </div>
              <br />
              <span className="w-100  text-13">Kids</span>
              <br />
              <div className="row">
                <div className="col-6 pl-0 text-13">
                  Ticket price
                  <br />
                  <input
                    type="text"
                    placeholder="Ticket price"
                    value={kidsSelectedPrice}
                    onChange={handle_kids_price}
                    className="edit-input"
                  />
                </div>
                <div className="col-6 pr-0 text-13">
                  Add or top-up tickets
                  <br />
                  <input
                    type="text"
                    placeholder="Load tickets"
                    value={kidsSelectedTicket}
                    onChange={handle_kids_tickets}
                    className="edit-input"
                  />
                </div>
              </div>
              <div className="row mt-3 mb-3">
                <div className="col-12 p-0">
                  <div className="h-divider w-100" />
                </div>
              </div>
              <div
                className="row justify-content-end align-self-center"
                style={{ marginBottom: -20 }}
              >
                <label className="back-arrow" style={{ marginRight: 15 }}>
                  <div className="save-btn" onClick={() => update()}>
                    <span
                      style={{
                        display: updateDisplay,
                      }}
                    >
                      Load
                    </span>
                    <span
                      style={{
                        display: spinning,
                      }}
                    >
                      <ClipLoader
                        color={'#fff'}
                        loading={true}
                        // css={override}
                        size={20}
                      />
                    </span>
                  </div>
                </label>

                <label className="back-arrow">
                  <div className="cancel-btn" onClick={() => cancel()}>
                    <span
                      style={{
                        display: updateDisplay,
                      }}
                    >
                      {cancelTitle}
                    </span>
                    <span
                      style={{
                        display: spinning,
                      }}
                    >
                      <ClipLoader
                        color={'#fff'}
                        loading={true}
                        // css={override}
                        size={20}
                      />
                    </span>
                  </div>
                </label>
              </div>
              <input type="text" value={currentSelect.toLowerCase()} style={{ display: 'none' }} />
            </div>
          </div>
        </Modal>
        <div className="row justify-content-center just-container-insid" style={{ marginTop: 90 }}>
          {/* <div className="col-lg-11 col-12 pl-2 pr-2">
              <label className={"category-name-heading"}>
                {checkcampaign == "yes" ? (
                  <Link
                    to="/campaignmanager"
                    className="link-color font-normal"
                  >
                    Go to campaign manager
                  </Link>
                ) : (
                  ""
                )}
              </label>
            </div> */}
          <div className="col-11 pl-2 pr-2">
            {is_sponsorship == true ? (
              <div className="sponsored-badge w-100 mb-3 p-2 text-center" style={{ fontSize: 16 }}>
                🌟 Tickets to this event are proudly sponsored by Karamale.
              </div>
            ) : (
              ''
            )}
          </div>
          <div className="col-lg-7 padding-added pl-2 pr-2">
            <div className=" BoxDashboardContainer mt-0 mb-4 mrgin-search pl-0 pr-0">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className={`${cancelledAt != null ? 'col-12 pl-0' : 'col-lg-5 col-6 pl-0'}`}>
                    <button type="button" onClick={() => history.goBack()} className="link-btn">
                      <IoIosArrowBack size={25} />
                      Back &nbsp;
                    </button>
                  </div>

                  <div
                    className={`${cancelledAt != null ? 'd-none' : 'col-lg-7 col-6 text-right'}`}
                  >
                    <label className="back-arrow mb-0">
                      <Link
                        to={{
                          pathname: 'updateeventdetails',
                          state: {
                            prevpage: prevpage,
                            currentage: 'editevent',
                            eventname: eventname,
                            eventdate: eventdate,
                            eventid: eventid,
                            poster: poster,
                            theme: theme,
                            venue: venue,
                            expectednum: expectednum,
                            enddate: enddate,
                            time: time,
                            endtime: endtime,
                            event_date: event_date,
                            finish_date: finish_date,
                          },
                        }}
                        className="link-btn"
                      >
                        <div className="edit-btn">Edit</div>
                      </Link>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="BoxDashboardContainer pl-0 pr-0 mb-4">
              <div className="row align-self-center justify-content-center">
                <div className="col-lg-12 p-0">
                  <label className="ticket-title mb-0">
                    <h5>{eventname}</h5>
                    {deletion}
                    {/* <label class="small-details">{eventdate}</label> */}
                  </label>
                </div>

                <div className="h-divider w-100"></div>
              </div>

              <div className="col-lg-12 details-body mb-3">
                {preimage !== 'none' ? (
                  <img src={preimage} width={'100%'} className="img-poster" />
                ) : (
                  <div
                    className="no-poster-text text-center p-5 cursor-pointer"
                    onClick={event_date >= fulldate && deleted == 0 ? addAPoster : functionControl}
                  >
                    <IoImageOutline size={50} color={'grey'} />
                    <br />
                    No poster uploaded
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-lg-4 p-0">
            {/* <div className="col-lg-12 tickets-assigned"> */}
            <div className="col-lg-12  pl-2 pr-2">
              <div className=" BoxDashboardContainer mt-0 mb-4 pb-3 p-3">
                <div className="row align-items-center justify-content-center">
                  <div className="col-12 align-items-center p-0 mb-3">
                    <button
                      type="button"
                      className={`${
                        checkCampaignStatus === 'stop' ? 'save-btn' : 'btn btn-info text-bold'
                      } text-underline-none w-100`}
                      onClick={() => resumeAModal()}
                      style={{ padding: '5px 10px 5px 10px' }}
                    >
                      {statusString}
                    </button>
                  </div>

                  <div className="col-6 align-items-center pl-0 pr-1">
                    <Link
                      to={{
                        pathname: '/payout',
                        state: {
                          eventid: eventid,
                          eventname: eventname,
                          is_sponsorship: is_sponsorship,
                        },
                      }}
                      type="button"
                      className="text-underline-none w-100"
                    >
                      <label className="cancel-btn text-center w-100">Payout</label>
                    </Link>
                  </div>

                  <div className="col-6 pr-0 pl-1">
                    <Link
                      to={{
                        pathname: '/view-refund-request',
                        state: {
                          eventid: eventid,
                          eventname: eventname,
                          is_sponsorship: is_sponsorship,
                        },
                      }}
                      type="button"
                      className="text-underline-none w-100"
                    >
                      <label className="cancel-btn text-center w-100">Refunds</label>
                    </Link>
                  </div>
                </div>
              </div>
              <div className=" BoxDashboardContainer mt-0 mb-0 pb-3 pl-3 pr-3">
                <div className="item-select w-100 mb-2">
                  <Link
                    to={{
                      pathname: 'analytics',
                      state: {
                        campaignstatus: campaignstatus,
                        eventid: eventid,
                        eventname: eventname,
                        poster: poster,
                        eventdate: eventdate,
                        enddate: enddate,
                        event_date: event_date,
                        finish_date: finish_date,
                        theme: theme,
                        venue: venue,
                        expectednum: expectednum,
                        time: time,
                        endtime: endtime,
                        prevpage: prevpage,
                        back: 'editevent',
                      },
                    }}
                    className="w-100 menu-links"
                  >
                    <div className="col-lg-2 col-2 col-sm-1 text-center">
                      <IoAnalyticsOutline size={30} className={analyticsActive} />
                    </div>
                    <div className="col-lg-10 col-10 col-sm-11">
                      <label className={analyticsActive + ' w-100 mb-0'}>
                        Analytics
                        <label
                          className="float-right"
                          style={{
                            color: 'rgb(102, 178, 102)',
                            fontSize: 15,
                          }}
                        >
                          {/* <i>New</i> */}
                        </label>
                      </label>
                    </div>
                  </Link>
                </div>

                <div
                  className={`${
                    cancelledAt != null ? 'd-none' : 'item-select w-100 mb-2 menu-links'
                  }`}
                  onClick={event_date >= fulldate && deleted == 0 ? openModal : functionControl}
                >
                  <div className="w-100 menu-links ">
                    <div className="col-lg-2 col-2 col-sm-1 text-center">
                      <IoTicketOutline size={30} className={active} />
                    </div>
                    <div className="col-lg-10 col-10 col-sm-10">
                      <label className={active + ' w-100 mb-0'}>
                        Load tickets{' '}
                        {checktickets == 'no' ? (
                          <label className="float-right" data-tip={'Please load tickets'}>
                            {' '}
                            <IoIosInformationCircleOutline size={20} color={'red'} />
                            <ReactTooltip />
                          </label>
                        ) : (
                          <label className="float-right">
                            {' '}
                            <IoIosCheckmarkCircleOutline size={20} color={'#66b266'} />
                          </label>
                        )}
                      </label>
                    </div>
                  </div>
                </div>

                <div className={`${cancelledAt != null ? 'd-none' : 'item-select w-100 mb-2'}`}>
                  <div
                    className="w-100 menu-links "
                    onClick={event_date >= fulldate && deleted == 0 ? addAPoster : functionControl}
                  >
                    <div className="col-lg-2 col-2 col-sm-1 text-center">
                      <IoImageOutline size={30} className={active} />
                    </div>
                    <div className="col-lg-10 col-10 col-sm-10">
                      <label className={active + ' w-100 mb-0'}>
                        Upload poster
                        {checkposter == 'no' ? (
                          <label className="float-right" data-tip={'Add poster to this event'}>
                            {' '}
                            <IoIosInformationCircleOutline size={20} color={'red'} />
                            <ReactTooltip />
                          </label>
                        ) : (
                          <label className="float-right">
                            {' '}
                            <IoIosCheckmarkCircleOutline size={20} color={'#66b266'} />
                          </label>
                        )}
                      </label>
                    </div>
                  </div>
                </div>

                <div className={`${cancelledAt != null ? 'd-none' : 'item-select w-100 mb-2'}`}>
                  <div
                    className="w-100 menu-links "
                    onClick={
                      event_date >= fulldate &&
                      deleted == 0 &&
                      checktickets == 'yes' &&
                      checkposter == 'yes'
                        ? campaign
                        : functionControl
                    }
                  >
                    <div className="col-lg-2 col-2 col-sm-1 text-center">
                      <IoFlowerOutline size={30} className={active} />
                    </div>
                    <div className="col-lg-10 col-10 col-sm-10">
                      <label className={active + ' w-100 mb-0'}>
                        Create/edit campaign
                        {checkcampaign == 'no' ? (
                          <label
                            className="float-right"
                            data-tip={'Create a campaign to activate this event'}
                          >
                            {' '}
                            <IoIosInformationCircleOutline size={20} color={'red'} />
                            <ReactTooltip />
                          </label>
                        ) : (
                          <label className="float-right">
                            {' '}
                            <IoIosCheckmarkCircleOutline size={20} color={'#66b266'} />
                          </label>
                        )}
                      </label>
                    </div>
                  </div>
                </div>

                {/* {eventtype == "beauty pageant" ? (
                    <div className="item-select w-100 mb-2">
                      <div
                        className="w-100 menu-links "
                        onClick={
                          event_date >= fulldate &&
                          deleted == 0 &&
                          checktickets == "yes" &&
                          checkposter == "yes" &&
                          checkcampaign == "yes"
                            ? addModels
                            : functionControl
                        }
                      >
                        <div className="col-lg-2 col-2 col-sm-1 text-center">
                          <div className="row">
                            <div className="col-6 p-0">
                              <IoMdWoman size={17} className={active} />
                            </div>
                            <div className="col-6 p-0">
                              <IoIosMan size={15} className={active} />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-10 col-10 col-sm-10">
                          <label className={active + " w-100 mb-0"}>
                            Add models
                            <label className="float-right color-green">
                              <i>New</i>
                            </label>
                          </label>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )} */}

                <div className={`${cancelledAt != null ? 'd-none' : 'item-select w-100 mb-2'}`}>
                  <div
                    className="w-100 menu-links "
                    onClick={
                      event_date >= fulldate &&
                      deleted == 0 &&
                      checktickets == 'yes' &&
                      checkposter == 'yes' &&
                      checkcampaign == 'yes'
                        ? downloadTickets
                        : functionControl
                    }
                  >
                    <div className="col-lg-2 col-2 col-sm-1 text-center">
                      {ticketCount > 0 ? (
                        <IoCloudDoneOutline size={30} className={active} />
                      ) : (
                        <IoCloudDownloadOutline size={30} className={active} />
                      )}
                    </div>
                    <div className="col-lg-10 col-10 col-sm-10">
                      <label className={active + ' w-100 mb-0'}>
                        Download tickets
                        <span className={ticketCount > 0 ? 'float-right' : 'd-none'}>
                          <IoIosCheckmarkCircleOutline size={20} color={'#66b266'} />
                        </span>
                      </label>
                    </div>
                  </div>
                </div>

                {cancelledAt != null ? '' : ticketCount <= 0 ? <></> : printed}
              </div>
            </div>
            {/* <div className="col-lg-12 tickets-assigned"> */}
            <div className="col-lg-12  pl-2 pr-2">
              <div className=" BoxDashboardContainer mt-4 mb-4 pb-3 ">
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0">
                    <div className="col-lg-12 pl-0">
                      <label className="ticket-title">MORE ACTION</label>
                    </div>
                  </div>
                </div>

                <div className="h-divider w-100" />
                <div className={`${cancelledAt != null ? 'd-none' : 'item-select w-100 mb-2'}`}>
                  <div
                    className="w-100 menu-links "
                    onClick={event_date >= fulldate && deleted == 0 ? postpone : functionControl}
                  >
                    <div className="col-lg-2 col-2 col-sm-1 text-center">
                      <IoBicycleOutline size={30} className={active} />
                    </div>
                    <div className="col-lg-10 col-10 col-sm-10">
                      <label className={active}>Postpone event</label>
                    </div>
                  </div>
                </div>

                <div className={`${cancelledAt != null ? 'd-none' : 'item-select w-100 mb-2'}`}>
                  <div
                    className="w-100 menu-links "
                    onClick={event_date >= fulldate && deleted == 0 ? cancelModal : functionControl}
                  >
                    <div className="col-lg-2 col-2 col-sm-1 text-center">
                      <IoNuclearOutline size={30} className={active} />
                    </div>
                    <div className="col-lg-10 col-10 col-sm-10">
                      <label className={active}>Cancel event</label>
                    </div>
                  </div>
                </div>

                <div
                  className="item-select w-100 mb-2"
                  onClick={event_date >= fulldate && deleted == 0 ? delModal : functionControl}
                  // onClick={() => deleteModal()}
                >
                  <div className="w-100 menu-links ">
                    <div className="col-lg-2 col-2 col-sm-1 text-center">
                      <IoTrashOutline size={30} className={active} />
                    </div>
                    <div className="col-lg-10 col-10 col-sm-10">
                      <label className={active}>Delete event</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={successError} style={{ display: errorDisplay, textAlign: 'center' }}>
        {error}
      </div>
    </div>
  )
}

export default Editevent
